import { PatchProfileCommand } from '../models/patch-profile.command';

export class PatchProfile {
    static readonly type = '[User] PatchProfile';

    constructor(public payload: PatchProfileCommand) {}
}
